import { createContext, useContext } from 'react';

type NavigationContextModel = {
	shouldCollapse: boolean;
};

const NavigationContext = createContext<NavigationContextModel | undefined>(undefined);

const useNavigationContext = () => {
	const context = useContext(NavigationContext);

	if (context === undefined) {
		throw new Error('useNavigationContext must be used within a NavigationContext provider');
	}

	return context;
};

export { NavigationContext, useNavigationContext };
export type { NavigationContextModel };
